import { useQuery } from "@tanstack/react-query";
import { BookingCalendar } from "PFApp/booking/types";
import { PER_PAGE_UNPAGINATED } from "PFApp/constants/unpaginated";
import { useGrowl } from "PFApp/use_growl";
import { getCalendars } from "PFCore/services/booking_config";
import { Collection } from "PFTypes";

import { bookingConfigKeys } from "./query_keys";

export const useBookingConfigCalendars = (page = 1, perPage = PER_PAGE_UNPAGINATED) => {
  const growl = useGrowl();

  return useQuery<Collection<BookingCalendar[]>>({
    queryKey: bookingConfigKeys.calendars(page, perPage),
    queryFn: async () => getCalendars(page, perPage),
    onError: (error: any) => {
      growl({
        message: error.responseJSON.errors[0].detail,
        kind: "error"
      });
    }
  });
};
